import PropTypes from 'prop-types'
import React from 'react'
import Loader from '../Loader'

export const SingleLoader = ({ color, height }) => {
  const divStyle = {
    width: '100%',
    height: height
  }

  const top = parseInt(height) / 2

  return (
    <>
      <div style={divStyle}>
        <Loader
          loaded={false}
          lines={6}
          length={0}
          width={7}
          radius={10}
          corners={1}
          rotate={0}
          direction={1}
          color={color}
          speed={1.4}
          shadow={false}
          className='spinner'
          top={top + 'px'}
          left={'50%'}
          zIndex={200}
          loadedClassName=''
          position={'relative'}
        />
      </div>
    </>
  )
}

SingleLoader.defaultProps = {
  color: '#4CBAD7'
}

SingleLoader.propTypes = {
  height: PropTypes.string,
  color: PropTypes.string
}
